export const STARTING_TAB = 'startingTab';
export const WELCOME_TABS = {
  CREATE_ACCOUNT: '0',
  SIGN_IN: '1'
};

type StorageKey = 'startingTab' | 'visitId';

function canUseLocalStorage() {
  try {
    window.localStorage.setItem('test', 'test');
    window.localStorage.removeItem('test');
    return true;
  } catch (_) {
    return false;
  }
}

const localStorageAvailable = canUseLocalStorage();

function createStorage(storageType: 'localStorage' | 'sessionStorage') {
  function getItem(key: StorageKey): string | null {
    if (!localStorageAvailable) {
      return null;
    }

    return window[storageType].getItem(key);
  }

  function setItem(key: StorageKey, value: string) {
    if (localStorageAvailable) {
      window[storageType].setItem(key, value);
    }
  }

  function removeItem(key: StorageKey) {
    if (localStorageAvailable) {
      window[storageType].removeItem(key);
    }
  }

  return {
    getItem,
    removeItem,
    setItem
  };
}

export const sessionStorage = createStorage('sessionStorage');
export const localStorage = createStorage('localStorage');
